import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("systemConfigs")
export class SystemConfig extends BaseEntity {
  configName: string;
  configValue: string;
}
